'use client';

import { Suspense } from 'react';
import { useSearchParams as useNextSearchParams, ReadonlyURLSearchParams } from 'next/navigation';

// Context to hold search params
import React, { createContext, useContext, ReactNode } from 'react';

// Create a context for search params
const SearchParamsContext = createContext<ReadonlyURLSearchParams | null>(null);

// Hook to safely access search params
export function useSafeSearchParams() {
  const context = useContext(SearchParamsContext);
  return context;
}

// Internal component that uses the Next.js hook
function SearchParamsResolver({ children }: { children: ReactNode }) {
  const searchParams = useNextSearchParams();
  
  return (
    <SearchParamsContext.Provider value={searchParams}>
      {children}
    </SearchParamsContext.Provider>
  );
}

// Main component that wraps everything in a Suspense boundary
export function SearchParamsProvider({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SearchParamsResolver>
        {children}
      </SearchParamsResolver>
    </Suspense>
  );
} 